import { render, staticRenderFns } from "./SelectBox2old.vue?vue&type=template&id=6e6b0640&"
import script from "./SelectBox2old.vue?vue&type=script&lang=js&"
export * from "./SelectBox2old.vue?vue&type=script&lang=js&"
import style0 from "./SelectBox2old.vue?vue&type=style&index=0&id=6e6b0640&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports